import styled from "styled-components";

import { ButtonPrimaryLink, ButtonSecondaryLink } from "@components/Button";
import Layout from "@components/Layout";

import { Row } from "@styles/grid";

import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { getAllBuckets } from "@actions/buckets.action";
import BucketsTable from "./BucketsTable";

const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin: 3rem auto 5.5rem;
  max-width: 125rem;
  width: 100%;
  padding: 0 2.5rem;
`;

const Buckets = () => {
  const { buckets } = useSelector(({ buckets }) => buckets);
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      const bucketsNotEmpty = buckets && buckets.length;
      if (!bucketsNotEmpty) {
        await dispatch(getAllBuckets());
      }
    })();
  }, []);

  return (
    <Layout pageTitle="Buckets">
      <Content>
        <Row justify="space-between" margin="2rem 0">
          <ButtonSecondaryLink outlined uppercase href="/">
            Back to Dashboard
          </ButtonSecondaryLink>
          <ButtonPrimaryLink uppercase href="/buckets/add">
            Add bucket
          </ButtonPrimaryLink>
        </Row>
        <BucketsTable />
      </Content>
    </Layout>
  );
};

export default Buckets;
